<template>
  <div class="">
    <div class=" pb-4">
      <strong>消息通知</strong>
    </div>
    <el-collapse @change="onChange" accordion v-if="list && list.length > 0" class="notice-wrapper">
      <el-collapse-item v-for="(item, index) in list" :key="index" :name="index" class="position-relative">
        <template slot="title">
          <i class="header-icon me-2 position-absolute" v-if="!item.is_read"></i><div :class="item.is_read ? 'text-muted' : ''">{{item.title}}</div>
        </template>
        <div v-html="item.content" class="notice-content"></div>
      </el-collapse-item>
    </el-collapse>
    <div class=" text-muted text-center m-t-20" v-if="list && list.length <= 0">
      暂无消息~
    </div>
    <div class="page w-100 text-center mt-3" v-if="total > 10">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="10"
        :current-page="searchData.page"
        @current-change="pageChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import NoticeService from '../../service/NoticeService.js'
export default {
  data () {
    return {
      list: null,
      searchData: {
        page: this.$route.query.page * 1 || 1,
        size: 10
      },
      total: 0
    }
  },
  methods: {
    init () {
      NoticeService.getList(this.searchData).then(res => {
        this.list = res.data.list.map(item => {
          item.content = item.content.replace(/\\n/g,"<br>")
          return item
        })
        this.total = res.data.count
      })
    },
    pageChange(e) {
      this.searchData.page = e;
    },
    onChange(e) {
      if (e && !this.list[e].is_read) {
        NoticeService.read({ id: this.list[e].id }).then(() => {
          this.list[e].is_read = 1
        })
      }
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    searchData: {
      deep: true,
      handler (newVal, oldVal) {
        for (var key in newVal) {
          if (newVal[key] === '' || newVal[key] === false || (newVal[key] === 'all' && key === 'status')) {
            newVal[key] = undefined
          }
        }
        this.$router.push({ path: '/notification', query: newVal }, () => {this.init()})
      }
    },
  }
}
</script>
<style scoped>
.notice-content::v-deep a{
  color: #0a58ca !important;
}
.notice-content::v-deep p{
  margin: 0;
}
.header-icon{
  width: 8px;
  height: 8px;
  display: inline-block;
  background: #f04142;
  border-radius: 10px;
  left: -10px;
}
</style>